import * as React from "react";
import type { SVGProps } from "react";

const VehicleSemiTractor = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M10.667 12.2817H5.55957"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.6688 8.6668H12.3344C12.1503 8.6668 12.001 8.5175 12.001 8.33333V5.99902H14.3352"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M12.3729 11.628C12.659 11.9141 12.7446 12.3444 12.5898 12.7182C12.4349 13.092 12.0702 13.3358 11.6655 13.3358C11.2609 13.3358 10.8961 13.0921 10.7412 12.7183C10.5864 12.3445 10.6719 11.9142 10.9581 11.628L10.9581 11.628C11.3488 11.2373 11.9822 11.2373 12.3729 11.628V11.628"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M3.03789 11.628C3.32402 11.9141 3.40963 12.3444 3.25481 12.7183C3.09998 13.0921 2.7352 13.3359 2.33057 13.3359C1.92594 13.3359 1.56114 13.0922 1.40628 12.7184C1.25141 12.3445 1.33699 11.9142 1.62309 11.6281L1.62329 11.6279C1.81088 11.4403 2.06532 11.3349 2.33061 11.335C2.5959 11.335 2.85032 11.4404 3.03788 11.628V11.628"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M5.15508 11.628C5.44121 11.9141 5.52682 12.3444 5.37199 12.7183C5.21717 13.0921 4.85239 13.3359 4.44776 13.3359C4.04313 13.3359 3.67833 13.0922 3.52347 12.7184C3.3686 12.3445 3.45417 11.9142 3.74028 11.6281L3.74048 11.6279C3.92807 11.4403 4.1825 11.3349 4.4478 11.335C4.71309 11.335 4.96751 11.4404 5.15507 11.628V11.628"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M12.6654 12.3349H14.0026C14.3709 12.3349 14.6695 12.0363 14.6695 11.6679V6.98081C14.6695 6.77367 14.6213 6.56937 14.5286 6.38411L13.7039 4.73525C13.478 4.28343 13.0161 3.99805 12.5109 3.99805H9.33398"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M1.33008 9.33448H9.33341V2.66504"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
));
VehicleSemiTractor.displayName = "VehicleSemiTractor";

export default VehicleSemiTractor;
